export const StoreUser = {
    state: {
        me: "user.me",
        detail: "user.detail",
        token: "user.token",
        CT: "user.CT",
    },
    set: "user/set",
    load: "user/load",
    setDetail: "user/setDetail",
    loadDetail: "user/loadDetail",
    login: "user/login",
    logout: "user/logout",
    get: "user/get",
    getDetail: "user/getDetail",
    getToken: "user/getToken",
};

export const StoreContract = {
    state: {
        list: "contract.list",
        listRequired: "contract.listRequired",        
    },
    setList: "contract/setList",
    setListRequired: "contract/setListRequired",
    loadList: "contract/loadList",
    loadListRequired: "contract/loadListRequired",
    getList: "contract/getList",
    getListRequired: "contract/getListRequired",
};

export const StoreCity = {
    state: {
        list: "city.list",
    },
    setList: "city/setList",
    loadList: "city/loadList",
    getList: "city/getList",
};

export const StoreDistrict = {
    state: {
        list: "district.list",
    },
    setList: "district/setList",
    loadList: "district/loadList",
    getList: "district/getList",
};

export const StoreNotification = {
    state: {
        list: "notification.list",
    },
    setListItem: "notification/setListItem",
    setList: "notification/setList",
    getEndSendDateUnReaded: "notification/getEndSendDateUnReaded",
    getEndSendDate: "notification/getEndSendDate",
    getCountUnReaded: "notification/getCountUnReaded",
    getCountReaded: "notification/getCountReaded",
    getListUnReaded: "notification/getListUnReaded",
    getListAll: "notification/getListAll",
};

export const StoreMessage = {
    state: {
        list: "message.list",
    },
    setListItem: "message/setListItem",
    setList: "message/setList",
    setListReaded: "message/setListReaded",

    getListEndId: "message/getListEndId",
    getEndDateUnReaded: "message/getEndDateUnReaded",
    getEndDateUnReadedUser: "message/getEndDateUnReadedUser",
    //getEndDateUnReadedStudent: "message/getEndDateUnReadedStudent",
    getCountUnReaded: "message/getCountUnReaded",
    getCountUnReadedUser: "message/getCountUnReadedUser",
    //getCountUnReadedStudent: "message/getCountUnReadedStudent",
    //getListUnReaded: "message/getListUnReaded",
    getListAll: "message/getListAll",
};

export const StoreAppointment = {
    state: {
        list: "appointment.list",
    },
    setList: "appointment/setList",
    loadList: "appointment/loadList",
    getList: "appointment/getList",
};

export const StoreStudent = {
    state: {
        list: "student.list",
    },
    setList: "student/setList",
    loadList: "student/loadList",
    getList: "student/getList",
    getId: "student/getId",
};

export const StoreTeacher = {
    state: {
        by: "teacher.by",
    },
    set: "teacher/set",
    load: "teacher/load",
    get: "teacher/get",
};

export const StoreClassRoom = {
    state: {
        list: "classRoom.list",
    },
    setList: "classRoom/setList",
    loadList: "classRoom/loadList",
    getList: "classRoom/getList",
};

export const StoreLessonArea = {
    state: {
        list: "lessonArea.list",
    },
    setList: "lessonArea/setList",
    loadList: "lessonArea/loadList",
    getList: "lessonArea/getList",
};

export const StoreLessonGroup = {
    state: {
        list: "lessonGroup.list",
    },
    setList: "lessonGroup/setList",
    loadList: "lessonGroup/loadList",
    getList: "lessonGroup/getList",
};

export const StoreLesson = {
    state: {
        list: "lesson.list",
    },
    setList: "lesson/setList",
    loadList: "lesson/loadList",
    getList: "lesson/getList",
};

export const StoreLessonSubject = {
    state: {
        list: "lessonSubject.list",
    },
    setList: "lessonSubject/setList",
    loadList: "lessonSubject/loadList",
    getList: "lessonSubject/getList",
};

export const StoreLessonTeacher = {
    state: {
        list: "lessonTeacher.list",
    },
    setList: "lessonTeacher/setList",
    loadList: "lessonTeacher/loadList",
    getList: "lessonTeacher/getList",
};

export const StoreLessonKBS = {
    state: {
        list: "lessonKBS.list",
    },
    setList: "lessonKBS/setList",
    loadList: "lessonKBS/loadList",
    getList: "lessonKBS/getList",
};

export const StoreHowToStudy = {
    state: {
        list: "howToStudy.list",
    },
    setList: "howToStudy/setList",
    loadList: "howToStudy/loadList",
    getList: "howToStudy/getList",
};

export const StorePackage = {
    state: {
        list: "packages.list",
    },
    setList: "packages/setList",
    loadList: "packages/loadList",
    getList: "packages/getList",
};

export const StoreGlobalFileCategory = {
    state: {
        list: "globalFileCategory.list",
    },
    setList: "globalFileCategory/setList",
    loadList: "globalFileCategory/loadList",
    getList: "globalFileCategory/getList",
};